<template>
  <form @submit.prevent="save">
    <div class="order-operation-notes-modal modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Create Note</p>
      </header>
      <section class="modal-card-body">
        <base-select
          :service="vettedStatementService"
          fetch-func="all"
          label="Vetted Note"
          value-key="longText"
          label-key="longText"
          :disabled="inputs.description != ''"
          @input="(val) => onInput('vettedNote', val)"
          ref="selectVettedNote"
        ></base-select>
        <b-field label="Description">
          <b-input
            type="textarea"
            :disabled="inputs.vettedNote != ''"
            @input="(val) => onInput('description', val)"
          ></b-input>
        </b-field>
        <b-checkbox v-model="inputs.is_sensitive">Confidential</b-checkbox>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Cancel</button>
        <button :class="`button is-info ${loading ? 'is-loading' : ''}`">Save</button>
      </footer>
    </div>
  </form>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { OrderOperationService } from "@/services/orderOperation.service";
import { VettedStatementService } from "@/services/vettedStatement.service";

export default {
  props: {
    operationId: {
      type: Number | String,
      required: true
    }
  },
  components: {
    BaseSelect
  },
  data: () => ({
    orderOperationService: OrderOperationService,
    vettedStatementService: VettedStatementService,
    inputs: {
      vettedNote: "",
      description: "",
      is_sensitive: false
    },
    loading: false
  }),
  methods: {
    onInput(key, val) {
      this.inputs[key] = val;
    },
    save() {
      let data = {
        comment: this.inputs.vettedNote || this.inputs.description,
        is_vetted_order_activity: this.inputs.vettedNote ? 1 : 0,
        is_sensitive: this.inputs.is_sensitive ? 1 : 0
      };

      this.loading = true;

      this.orderOperationService.createComment(this.operationId, data).then(
        response => {
          this.$buefy.toast.open({
            message: "Note has been created.",
            type: "is-info",
            position: "is-top-right"
          });
          this.loading = false;
          this.$emit("create-success", JsonDenormalizer.denormalize(response));
          this.$parent.close();
        },
        err => {
          this.loading = false;
          this.$parent.close(); // closing it for now since it covers the error modal
        }
      );
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderOperationNotesModal.vue